<script>
	// MenuItemList - Adaptable Component
	const MenuItemList = (resolve) => {
		require.ensure([], () => {
			resolve(require('./MenuItemList/MenuItemList'));
		});
	};
	const MenuItemListDescriptive = (resolve) => {
		require.ensure([], () => {
			resolve(require('./MenuItemList/MenuItemListDescriptive'));
		});
	};
	const MenuItemProfileList = (resolve) => {
		require.ensure([], () => {
			resolve(require('./MenuItemList/MenuItemProfileList'));
		});
	};
	export default {
		props: {
			categoryId: {
				type: String,
				default: ''
			},
		},
		data() {
			return {
				useComponent: 'MenuItemList',
			};
		},
		computed: {
			getComponent() {
				const componentMap = (useComponent) => {
					switch (useComponent) {
						case 'MenuItemDescriptive': // Note this is an adapted dependency
							return MenuItemListDescriptive;
						case 'MenuItemProfileList': // Note this is an adapted dependency
							return MenuItemProfileList;
						default:
							return MenuItemList; // default component
					}
				};
				const useComponent = this.useComponent;
				return componentMap(useComponent);
			}
		},
		methods: {
			// Menu Item List has an adaption dependency "Menu Item"
			setupComponent() {
				const screen = this.$mq === 'mobile' ? 'mobile' : 'desktop';
				const useComponent = this.$layouts.getComponent({
					screen,
					route: this.$route.name,
					adapter: 'MenuItemList',
				});
				// const useComponent = this.$layouts[screen]['MenuItemList'][this.$route.name];
				this.useComponent = useComponent;
			}
		},
		created() {
			this.setupComponent();
		},
		watch: {
			$mq(newValue, oldValue) {
				if (newValue !== oldValue) {
					this.setupComponent();
				}
			}
		}
	}
</script>

<template>
	<div class="menu-category-wrapper">
		<component :is="getComponent"
			:categoryId="categoryId">
		</component>
	</div>
</template>


// WEBPACK FOOTER //
// src/components/menu/Adapter_MenuItemList.vue